import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import SectionHeader from '../SectionHeader';

export default class BenefitDetails extends React.Component {
  render() {
    const { titleText, titleDescription, benefits, pageType } = this.props;

    const benefitGrid = _.map(benefits, (benefit, index) => (
      <div key={index} className="column">
        <img className="ui fluid image" src={require(`../../assets/${benefit.imageUrl}`)} />
        <h3 className="thick-text">{index + 1}. {benefit.text}</h3>
        <h4 className="no-top">{benefit.description}</h4>
      </div>
    ));

    return (
      <div className={classnames('BenefitDetails', pageType)}>
        <div className="ui container">
          <SectionHeader titleText={titleText} titleDescription={titleDescription} />
          <div className="ui grid stackable p-b-4">
            <div className="equal width row">
              {benefitGrid}
            </div>
          </div>
        </div>
        <div className="ui divider" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/BenefitDetails/index.jsx